var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeutschePostLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DP_Markenclip",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 108.9997 106.0001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#baa03e;}.cls-2{fill:url(#Unbenannter_Verlauf);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf",
    y1: 106,
    x2: 1,
    y2: 106,
    gradientTransform: "matrix(0, 103, 103, 0, -10862.0003, 0.0002)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ffe680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    stopColor: "#ffd942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#ffd012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "logo-gradient cls-2",
    x: 5.9997,
    y: 0.0002,
    width: 100,
    height: 103
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1719,67.5078h8.94l-9.029,9.122h-8.941ZM24.0813,76.63h8.943l9.026-9.122h-8.939Zm41.0476-9.122h-8.942l9.03,9.122h8.94Zm12.0606,0h-8.942l9.029,9.122h8.94Zm13.23-36.498c-1.269,18.586-15.232,34.865-35.949,34.856-23.435-.006-32.495-20.346-31.275-35.758l6.883-2.186c-1.119,8.771,1.601,15.097,3.476,17.996-2.233-12.408,7.15-22.452,18.894-22.46,10.564-.007,19.301,7.693,19.259,18.741a58.5029,58.5029,0,0,0,2.851-15.13ZM65.1751,42.59a12.694,12.694,0,1,0-12.696,12.672A12.6817,12.6817,0,0,0,65.1751,42.59Z",
    transform: "translate(-0.0003 0.0002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeutschePostLogo);
export default __webpack_public_path__ + "static/media/deutsche_post_logo.f8fe45f0dce4f441e4ea8e02d48775b6.svg";
export { ForwardRef as ReactComponent };